import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        list: [],
		pager: {},
		loading: false,
		sendSmsList: [] //批量出库发送短信列表
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		},
		setSmsList(state: any) {
			const list:any = window.localStorage.getItem('batchList')
            if(list){
                state['sendSmsList'] = JSON.parse(list);
            }else{
                state['sendSmsList'] = [];
            }
			
		}
	},
	actions: {
		// 获取手机搜索列表
		getPhoneTips({ commit }: any, params: any) {
			return fetch({
				url: '/common/getPhoneTips',
				params,
			})
			
		},
		// 入库
		putStorage({ commit }: any, params: any) {
			return fetch({
				url: '/client/packages',
				method: 'post',
				data: params,
			})
		},
		// 批量入库
		async putBatchStorage({ commit }: any, params: any) {
			return  await fetch({
				url: '/client/packages',
				method: 'post',
				data: {...params,multi:true}
			})
		},
		// 通过快递单号查询该条信息详情
		async getCodeInfo({ commit }: any, params: any) {
			return await fetch({
				url: '/common/getCodeInfo',
				params
			})
		},
	}
}